// File Metadata:
// Filename: NewShipmentLog.js
// Version: 1.00
// Created: 2022-10-21 21:02:37
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { startOfYesterday } from 'date-fns'
import React, { Component } from 'react'
import NewShipmentFormConfirm from './NewShipmentFormConfirm'
import NewShipmentFormHU from './NewShipmentFormHU'
import NewShipmentFormPicture from './NewShipmentFormPicture'
import NewShipmentFormTU from './NewShipmentFormTU'
import NewShipmentFormType from './NewShipmentFormType'

export class NewShipmentLog extends Component {
	state = {
		step: 1,
		type: '',
		sscc: '',
		tour: '000000', // Set default value
		img: [],
		notes: ['']
	}

	requiresTour = (type) => {
		return ['inbound', 'outbound', 'picklist', 'tour'].includes(type);
	}

	// Proceed to next step
	nextStep = () => {
		const { step, type } = this.state
		
		// Skip tour step if not required for this type
		if (step === 2 && !this.requiresTour(type)) {
			this.setState({ step: step + 2 })
			return
		}
		
		this.setState({ step: step + 1 })
	}

	prevStep = () => {
		const { step } = this.state
		this.setState({ step: step - 1 })
	}

	handleChange = input => e => {
		this.setState({ [input]: e.target.value })
	}

	handleValue = (input, value) => {
		this.setState({ [input]: value })
	}

	// Before submitting to server, ensure tour has default value if not required
	getTourValue = () => {
		return this.requiresTour(this.state.type) ? this.state.tour : '000000'
	}

	// Update the values object passed to child components
	render() {
		const { step, type, sscc, tour, img } = this.state
		const values = { 
			step, 
			type, 
			sscc, 
			tour: this.getTourValue(), // Use getter method
			img 
		}

		switch (step) {
			case 1:
				return <NewShipmentFormType nextStep={this.nextStep} handleChange={this.handleChange} values={values} />
			case 2:
				return (
					<NewShipmentFormHU
						nextStep={this.nextStep}
						prevStep={this.prevStep}
						handleValue={this.handleValue}
						values={values}
					/>
				)
			case 3:
				// Only show tour form if required
				return this.requiresTour(type) ? (
					<NewShipmentFormTU
						nextStep={this.nextStep}
						prevStep={this.prevStep}
						handleChange={this.handleChange}
						values={values}
					/>
				) : null;
			case 4:
				return (
					<NewShipmentFormPicture
						nextStep={this.nextStep}
						prevStep={this.prevStep}
						handleValue={this.handleValue}
						values={values}
					/>
				)
			case 5:
				return <NewShipmentFormConfirm prevStep={this.prevStep} values={values} />
		}
	}
}

export default NewShipmentLog
